import {ToggleGroup} from 'omni-toggle';
import $ from 'jquery';

App.registerBehavior('Accordion', function (appSettings) {
  const settings = 'undefined' != typeof appSettings['accordion/accordion'] && appSettings['accordion/accordion'] || {};
  // Items to expand on page load
  let expandItems = 'undefined' !== typeof settings['expand_items'] && [settings['expand_items']] || [];

  if (window.location.hash) {
    // Re-open items (that were clicked before)
    expandItems.push(`.accordion__item${window.location.hash}`);
  }
  $('.accordion').once('AccordionBehavior').each(function () {
    const toggleGroup = new ToggleGroup(this, {
      items: '.accordion__item',
      button: '.accordion__item-toggle',
      content: '.accordion__item-content',
      initial: 0 < expandItems.length ? expandItems.join(', ') : false,
      selectButtonActiveClass: 'is-active',
      activateOnFocus: true,
      afterToggle: e => {
        if (e.detail.active && e.detail.originalEvent) {
          setLocationId(e.target.getAttribute('id'));
        }
      }
    });

    // So far not used, maybe a drop in for the custom tabbed implementation
    // new from omni 0.5
    if (this.classList.contains('accordion--tabbed')) {
      this.querySelectorAll('.tabs__item-link').forEach((tabItemLink, i) => {
        const toggleItem = toggleGroup.getItems()[i];
        const tabTitlePlaceholder = tabItemLink.querySelector('.tabs__item-title-placeholder');

        if (tabTitlePlaceholder) {
          // Special case: Tabs were not rendered completely. Retrieve tab title and href from accordion item.
          const accordionItem = toggleItem.getElement();
          const tabTitle = accordionItem.querySelector('.accordion__item-header').innerText;
          tabTitlePlaceholder.replaceWith(document.createTextNode(tabTitle));
          tabItemLink.setAttribute('href', '#' + accordionItem.getAttribute('id') + '-panel');
        }

        toggleItem.setSelectButton(tabItemLink);
      });

      if (toggleGroup.getItems().length > 0 && toggleGroup.getActiveItems().length === 0) {
        toggleGroup.getItems()[0].activate();
      }
    }
  });
});

function setLocationId(id) {
  if (id && window.history.replaceState) {
    window.history.replaceState({}, '', `#${id}`);
    /**
     * Forces has "hashchange" event.
     * This keeps the window.location.hash in sync with the opened accordion item,
     * even if the user clicks on an accordion item that is already open
     * (and thus does not trigger a hash change by itself).
     */
    window.dispatchEvent(new Event('hashchange'));
  }
}
